import { render, staticRenderFns } from "./Professions.vue?vue&type=template&id=3e0b68c3"
import script from "./Professions.vue?vue&type=script&lang=js"
export * from "./Professions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports